
import {createSlice} from "@reduxjs/toolkit";

export const subscriberSlice = createSlice({
    name: 'subscriberSlc',
    initialState: {value: {id: null, externalId: null, service: null, source: null,
            subCount: null, countDate: null, status: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            subscriberDrawerState: false, subscriberDrawerMode: null, subscriberGridRefresh: false,
            subscriberUploadState: false
        }},
    reducers:

{
    changeSubscriber: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeSubscriber } = subscriberSlice.actions;

export default  subscriberSlice.reducer ;

